import { escapeHtml } from './helpers';
import { resolveMenuStyles, type MenuLink } from './menuBlockUtils';

export type MenuBlockContent = {
  links?: MenuLink[];
};

export type MenuBlockStyles = Record<string, unknown>;

const itemStyleString = (item: ReturnType<typeof resolveMenuStyles>['item']): string =>
  [
    `display: inline-block`,
    `color: ${item.color}`,
    `text-decoration: ${item.textDecoration}`,
    `padding: ${item.padding}`,
    `border-radius: ${item.borderRadius}`,
    `border: ${item.border}`,
    `background-color: ${item.backgroundColor}`,
    `box-shadow: ${item.boxShadow}`,
    `text-transform: ${item.textTransform}`,
    `letter-spacing: ${item.letterSpacing}`,
    `font-size: ${item.fontSize}`,
    `font-weight: ${item.fontWeight}`,
    `font-family: inherit`,
    `white-space: ${item.whiteSpace}`,
    `line-height: ${item.lineHeight}`,
    `vertical-align: ${item.verticalAlign}`,
    `margin: ${item.margin}`,
  ].join('; ');

export const renderMenuBlockHtml = (
  content: MenuBlockContent,
  styles: MenuBlockStyles,
  fontFamily: string,
  isMobile = false
): string => {
  const links = Array.isArray(content.links) ? content.links : [];
  const resolved = resolveMenuStyles(styles, fontFamily, isMobile);
  const { container, item } = resolved;

  const linksHtml = links.length
    ? links
        .map((link) => {
          const href = escapeHtml(link.url || '#');
          const label = escapeHtml(link.label || 'Link');
          return `<a href="${href}" class="menu-item-link" target="_blank" rel="noopener noreferrer" style="${itemStyleString(item)}">${label}</a>`;
        })
        .join('')
    : '<span style="color: #64748B;">Add menu links</span>';

  let tableAlign: 'left' | 'center' | 'right' = 'center';
  if (container.textAlign === 'left') tableAlign = 'left';
  else if (container.textAlign === 'right') tableAlign = 'right';

  return `
    <div class="menu-block-wrap" style="padding: ${container.padding}; text-align: ${container.textAlign}; background-color: ${container.backgroundColor}; font-family: ${container.fontFamily}; font-size: ${container.fontSize}; font-weight: ${container.fontWeight}; color: ${item.color}; border-radius: ${container.borderRadius}; border: ${container.border}; box-shadow: ${container.boxShadow}; width: 100%; box-sizing: border-box;">
      <table role="presentation" border="0" cellspacing="0" cellpadding="0" width="100%" class="menu-block-table">
        <tr>
          <td align="${tableAlign}" valign="middle" class="menu-links-cell" style="text-align: ${container.textAlign}; vertical-align: middle; line-height: 1.25;">
            ${linksHtml}
          </td>
        </tr>
      </table>
    </div>
  `;
};
